@if (selectLastChild$ | async) {}
<div
  class="flex align-items-center justify-content-center top-header-tab relative"
  [ngClass]="{ 'active-tab': active() }"
  #headerTab
>
  <div class="active-left"></div>
  @if (tabData().isOutSideUrl) {
    <a
      class="inner-tab-container"
      (click)="navigateToMicroService(tabData(), !!tabData().children.length)"
    >
      <div class="inner-tab flex align-items-center gap-1">
        <span class="webkit-box-one-line body-medium-medium">{{
          tabData().name
        }}</span>
      </div>
    </a>
  } @else {
    <a
      class="inner-tab-container"
      [routerLink]="!tabData().children.length ? tabData().routeUrl : null"
    >
      <div
        class="inner-tab flex align-items-center gap-1"
        (click)="goTo(dropdown)"
        (keydown.enter)="goTo(dropdown)"
      >
        <span class="webkit-box-one-line body-medium-medium">{{
          tabData().name
        }}</span>
        @if (tabData().children.length) {
          <em class="ml-auto ph ph-caret-down"></em>
        }
      </div>
      <p-dropdown
        #dropdown
        styleClass="hidden-dropdown"
        [appendTo]="headerTab"
        [options]="tabData().children"
        [(ngModel)]="activeDropDownMenu"
        optionLabel="name"
        placeholder=""
        (onChange)="selectChild($event)"
      />
    </a>
  }
  <div class="active-right"></div>
</div>
